import initHero from './components/project/hero';

initHero();
